// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const OnboardingPackClient = registerClientReference(
    function() { throw new Error("Attempted to call OnboardingPackClient() from the server but OnboardingPackClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/(authenticated)/worker/onboarding-pack/client.tsx",
    "OnboardingPackClient",
);
